export default __webpack_public_path__ + "static/media/logo.483f2e4e.png";